export const MALL_STG_BASE_URL =
  'http://becon-homepage-stg-temporary.s3-website.ap-northeast-2.amazonaws.com';

export const MALL_PRD_BASE_URL = 'https://www.withbecon.com';

const isStg = process.env.REACT_APP_SERVER_BASE_URL === 'stg';
const URL = isStg ? MALL_STG_BASE_URL : MALL_PRD_BASE_URL;

export const goToProductDetailMallPage = (
  refreshToken: string,
  productId: string,
  variationId: string,
) => {
  let params = new URLSearchParams({
    from: 'app',
    refreshToken,
    productId,
    variationId,
  });
  window.location.href = `${URL}/products-detail?${params}`;
};

export const goToMallMypage = (refreshToken: string) => {
  let params = new URLSearchParams({
    from: 'app',
    refreshToken,
  });
  window.location.href = `${URL}/mypage?${params}`;
};

export const goToMallCartV2Page = (refreshToken: string) => {
  let params = new URLSearchParams({
    from: 'app',
    refreshToken,
  });
  window.location.href = `${URL}/cartV2?${params}`;
};

export const goToMallQuizPage = (
  refreshToken: string,
  isLatestQuiz: boolean,
) => {
  let params = new URLSearchParams({
    from: 'app',
    refreshToken,
    isLatestQuiz: String(isLatestQuiz),
  });
  window.location.href = `${URL}/quiz/1?${params}`;
};
